export default "__VITE_ASSET__Y$vo4cW6__"